import Vue from 'vue'
import VueRouter from 'vue-router'
import NotFound from '../views/404.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/easy-pay'
  },
  {
    path: '/calendar',
    name: 'Calendar',
    component: NotFound
  },
  {
    path: '/clients',
    name: 'Clients',
    component: NotFound
  },
  {
    path: '/services',
    name: 'Services',
    component: NotFound
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: NotFound
  },
  {
    path: '/gift-cards',
    name: 'Gift cards',
    component: NotFound
  },
  {
    path: '/online-courses',
    name: 'Online courses',
    component: NotFound
  },
  {
    path: '/statistics',
    name: 'Statistics',
    component: NotFound
  },
  {
    path: '/easy-pay',
    name: 'EasyPay',
    component: () => import('../views/EasyPay.vue')
  },
  {
    path: '/settings',
    name: 'Settings',
    component: NotFound
  },
  {
    path: '/apps',
    name: 'Apps',
    component: NotFound
  },
  {
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
